import styled from 'styled-components';

export const CurrencySymbol = styled.div<{ disabled?: boolean }>`
  display: flex;
  margin-right: ${({ theme }): string => theme.spacing_unit_x1};
  margin-left: ${({ theme }): string => theme.spacing_unit_x1};
  height: ${({ theme }): string => theme.spacing_unit_x4};
  align-items: center;
  background-color: ${({ disabled, theme }): string =>
    disabled ? theme.palette_gray_5 : theme.palette_white};
`;
